import { useNavigate } from 'react-router-dom'

import { MapMarker } from '@/components/map/map-marker'
import { MapRoot } from '@/components/map/map-root'
import { MapScale } from '@/components/map/map-scale'
import { MainCoordinates } from '@/models/coordinates'
import { brazilCoordinates } from '@/utils/brazil-coordinates'

import { MapType } from './map-type'

interface ShowMapProps {
  mapStyle: string
  mainCoordinates: MainCoordinates[] | null
  handleStyleChange(style: string): void
}

export function ShowMap({
  mainCoordinates,
  mapStyle,
  handleStyleChange,
}: ShowMapProps) {
  const navigate = useNavigate()

  return (
    <div className="drop-shadow-xs">
      <MapRoot
        style={{
          height: '70vh',
          width: '100%',
          borderRadius: '16px',
          borderBottomLeftRadius: '0',
          borderBottomRightRadius: '0',
        }}
        initialViewState={brazilCoordinates}
        mapStyle={`mapbox://styles/mapbox/${mapStyle}`}
        maxZoom={11}
      >
        <MapScale />

        {mainCoordinates &&
          mainCoordinates.map(
            ({ coordenadas, nome_resumido: name, id_propriedade: id }) => (
              <MapMarker
                key={id}
                lat={coordenadas.latitude_decimal}
                lng={coordenadas.longitude_decimal}
                text={name}
                onClick={() => navigate(`/property/${id}`)}
              />
            ),
          )}
      </MapRoot>

      <div className="flex flex-col items-center rounded-b-2xl bg-white px-10 py-6 sm:flex-row sm:space-x-0 lg:items-center">
        <div className="space-y-4 lg:flex lg:w-full lg:justify-between">
          <div className="flex items-center gap-2 text-bios-title">
            <span className="text-sm font-bold md:text-base 2xl:text-lg">
              Total de propriedades no mapa:
            </span>
            <span className="text-sm md:text-base 2xl:text-lg">
              {mainCoordinates?.length}
            </span>
          </div>
          <div className="flex">
            <MapType
              initialStyle={mapStyle}
              handleStyleChange={handleStyleChange}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
